import { render, staticRenderFns } from "./garden22.vue?vue&type=template&id=23e7a8e8&scoped=true&"
import script from "./garden22.vue?vue&type=script&lang=js&"
export * from "./garden22.vue?vue&type=script&lang=js&"
import style0 from "./garden22.vue?vue&type=style&index=0&id=23e7a8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7a8e8",
  null
  
)

export default component.exports